import { render, staticRenderFns } from "./caseinput.vue?vue&type=template&id=3008ead2&scoped=true&"
import script from "./caseinput.vue?vue&type=script&lang=js&"
export * from "./caseinput.vue?vue&type=script&lang=js&"
import style0 from "./caseinput.vue?vue&type=style&index=0&id=3008ead2&prod&lang=less&scoped=true&"
import style1 from "./caseinput.vue?vue&type=style&index=1&id=3008ead2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008ead2",
  null
  
)

export default component.exports